// recon-vat-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcv.flag.duplicate': 'Possible duplicate voucher',
  'rcv.flag.salesWithoutDoc': 'Sales without VAT require documentation',
  'rcv.flag.creditNote': 'Credit note — check the period allocation',
  'rcv.item.customer': 'Customer',
  'rcv.item.otherSale': 'Other sale',
  'rcv.item.purchase': 'Purchase',
  'rcv.check.registered': 'The business is VAT-registered for the period',
  'rcv.check.treatment': 'All transactions have a determined VAT treatment',
  'rcv.check.outgoing': 'Output VAT in the ledger matches the VAT codes',
  'rcv.check.incoming': 'Input VAT in the ledger matches the VAT codes',
  'rcv.check.direct': 'Direct postings to the VAT accounts are identified',
  'rcv.check.duplicates': 'Possible duplicates are identified',
  'rcv.check.deduction': 'Purchases with a restricted right of deduction are identified',
  'rcv.check.reverse': 'Reverse charge is identified',
  'rcv.check.import': 'Imports of goods have a customs declaration',
  'rcv.check.exempt': 'Sales without VAT are identified',
  'rcv.check.credit': 'Credit notes in the period are identified',
  'rcv.check.settlement': 'The settlement account was cleared from the previous period',
  'rcv.check.filed': 'The VAT return for the period has been submitted',
  'rcv.src.ledger': 'General ledger',
  'rcv.src.sales': 'Posted sales vouchers',
  'rcv.src.purchases': 'Posted purchase vouchers',
  'rcv.src.spec': 'VAT specification',
  'rcv.src.customs': 'Customs declarations',
  'rcv.src.filing': 'VAT return for the period',
  'rcv.src.payment': 'Payment and settlement',
  'rcv.src.ledgerDetail': '{count} postings on the VAT accounts in the period',
  'rcv.src.linesDetail': '{count} lines in the period',
  'rcv.src.specDetail': '{count} VAT codes with amounts',
  'rcv.src.customsDetail': '{registered} registered · {missing} missing',
  'rcv.src.filingDetail': '{period} · due {due}',
  'rcv.src.noTerm': 'No term found',
  'rcv.src.paymentDetail': '{count} payment(s) registered',
  'rcv.main.salesBasisNote': 'The basis sits on the income accounts, not on a VAT account.',
  'rcv.main.net': 'Net VAT for the period',
});
